import { OccurrenceRes } from "@/models/occurrences.model"
import { PHAClient } from "@/utils/axios"

export const getOccurrence = async (): Promise<OccurrenceRes> => {
  const response = await PHAClient.get(`/api/occurrence/all`)
  return response.data
}